import http from "../index";

export const getPharmacistPendingOrders = () => http.get("/order/waiting-pharmacist-and-packaging");

export const getCouriers = () => http.get("/order/couriers");
